/** The "?" sheet: every key the CRM answers to, in one place. */
import { Keycap } from "../components/kit";
import { Modal } from "../components/ui";
import { GO_TO, RECORD_KEYS } from "./useShortcuts";

export function ShortcutSheet({ onClose }: { onClose: () => void }) {
  const mac = /Mac/.test(navigator.platform);
  return (
    <Modal title="Keyboard shortcuts" onClose={onClose} width={520}>
      <div className="keys-sheet">
        <section>
          <h4 className="eyebrow">Anywhere</h4>
          <dl>
            <dt>
              <Keycap>/</Keycap> or <Keycap>{mac ? "⌘" : "Ctrl"}</Keycap>
              <Keycap>K</Keycap>
            </dt>
            <dd>Search people and policies</dd>
            <dt>
              <Keycap>?</Keycap>
            </dt>
            <dd>This list</dd>
            {GO_TO.map(([k, , label]) => (
              <div key={k} className="keys-pair">
                <dt>
                  <Keycap>G</Keycap> then <Keycap>{k.toUpperCase()}</Keycap>
                </dt>
                <dd>{label}</dd>
              </div>
            ))}
          </dl>
        </section>
        <section>
          <h4 className="eyebrow">On a lead, customer or policy</h4>
          <dl>
            {RECORD_KEYS.map(([k, label]) => (
              <div key={k} className="keys-pair">
                <dt>
                  <Keycap>{k.toUpperCase()}</Keycap>
                </dt>
                <dd>{label}</dd>
              </div>
            ))}
            <dt>
              <Keycap>Enter</Keycap> / <Keycap>Esc</Keycap>
            </dt>
            <dd>Save or cancel a field you are editing</dd>
          </dl>
        </section>
      </div>
    </Modal>
  );
}
